import moment from 'moment';
import { useEffect, useState } from 'react';

const displayTimeRemaining = (endTime: number, optionalHours?: boolean) => {
  const diff = moment(endTime).diff(moment());
  if (diff > 0) {
    const duration = moment.duration(diff);
    const hours = duration.hours() + duration.days() * 24;
    const minutes = duration.minutes().toString();
    const seconds = duration.seconds().toString().padStart(2, '0');

    if (optionalHours) {
      if (hours === 0) {
        return `${minutes}:${seconds}`;
      }
      return `${hours}:${minutes.padStart(2, '0')}:${seconds}`;
    }
    return `${hours}:${minutes.padStart(2, '0')}:${seconds}`;
  }
  return undefined;
};

export const useCountdownTimer = (
  endTime: number | undefined,
  optionalHours?: boolean,
) => {
  const [timerDisplay, setTimerDisplay] = useState<string | undefined>(
    undefined,
  );

  useEffect(() => {
    if (endTime) {
      const performCountDown = () => {
        if (endTime) {
          setTimerDisplay(displayTimeRemaining(endTime, optionalHours));
        }
      };
      performCountDown();
      const interval = setInterval(performCountDown, 500);
      return () => {
        clearInterval(interval);
        setTimerDisplay(undefined);
      };
    }
  }, [endTime, optionalHours]);

  return timerDisplay;
};
